module.exports = __webpack_public_path__ + "img/oracle.2c773185.svg";